import styled from "styled-components";
import { motion } from "framer-motion";

const FichaProducto = styled.div`
  padding: 30px;
  max-width: 900px;
  margin: 0 auto;
  margin-top: 30px;
  
  
  a {
    background-color:  #000;
    color: #fff;
    padding: 10px 30px;
    text-decoration: none;
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .flechaSig {
    right: 0;
  }
  .flechaBack {
    left: 0;
  }
  h2 {
    margin-bottom: 15px;
  }
`;
const Galeria = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin: 30px 0;
`;
const MotionImagen = styled(motion.img)`
  width: 100%;
  max-width: 500px;
  height: auto;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0,0,0,0.2);
`;

const Flecha = styled.button`
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  color: #000;
  transition: transform 0.2s;
  position: absolute;
  transition: transform .4s;
  transform: scale(1);

  &:active {
    transform: scale(.5);
  }

`;

const Miniaturas = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 840px;
  margin: auto;
`;

const Miniatura = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  text-align: center;
  transition: transform 0.2s, border 0.3s;
  min-width: 90px;
  max-width: 90px;
  display: flex;
  flex-direction: column;
  gap: 3px;

  img {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: 100%;
    border: ${({ activa }) => (activa ? '2px solid #010755' : '2px solid #ccc')};
  }

  span {
    text-align: center;
    display: block;
    margin-top: 5px;
    font-size: 0.85rem;
    color: #333;
  }

  &:hover {
    transform: scale(1.05);
  }
`;

export {FichaProducto, Galeria, MotionImagen, Flecha, Miniaturas, Miniatura}